import React from 'react';

import { ComponentProps } from '../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../utils/styles';
import './strip-label.scss';

export interface IStripLabel extends ComponentProps {
  children?: JSX.Element;
  label?: string;
  cssModifier?: string;
}

const classNames = (cssModifier?: string): IClassNames =>
  makeClassNames({
    StripLabel: 'strip-label',
    StripLabelIcon: 'strip-label__icon',
    StripLabelText: ['strip-label__text', cssModifier && `strip-label__text--${cssModifier}`],
  });

const StripLabel: React.FC<IStripLabel> = ({ children, label, cssModifier }) => {
  const cn = classNames(cssModifier);
  return (
    <div className={cn.StripLabel}>
      <span className={cn.StripLabelText}>
        {children && <span className={cn.StripLabelIcon}>{children}</span>}
        {label}
      </span>
    </div>
  );
};

export default StripLabel;
